import React from "react"
import PostItem from "./postItem"

import styles from "./postList.module.scss"

const PostList = props => {
  return (
    <div className={styles.postList}>
      {props.posts &&
        props.posts.map(({ node: post }) => (
          <PostItem
            key={post.id}
            post={post}
            postType={props.postType}
            colorPalette={post?.category?.colorPalette}
          />
        ))}
    </div>
  )
}

export default PostList
